import { Box } from '@/ui/primitives';
import { buildDataStateMessageFrameSx } from './statePanelStyles';
import { StatusBanner } from './StatusBanner';
import type { UiTone } from '@/theme/uiTokens';
import type { ReactElement } from 'react';

type DataStateMessageProps = {
  message: string;
  tone?: UiTone;
  dense?: boolean;
  variant?: 'table' | 'card';
};

export const DataStateMessage = ({
  message,
  tone = 'blue',
  dense = true,
  variant = 'table',
}: DataStateMessageProps): ReactElement => {
  if (tone === 'red') {
    return (
      <Box sx={buildDataStateMessageFrameSx({ variant })}>
        <StatusBanner tone={tone} dense={dense} message={message} />
      </Box>
    );
  }

  return (
    <Box sx={buildDataStateMessageFrameSx({ variant })}>
      <StatusBanner tone={tone} dense={dense} message={message} />
    </Box>
  );
};
